
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PortalConfiguration from "./PortalConfiguration";
import { configAction, alertActions, masterActions } from '_store';
import { useForm } from 'react-hook-form';
import { Typography, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import AddRole from './AddRole';
import RoleList from './RoleList';
import { useCheckAdminRole } from '_utils/role-access';
import { ERR_MSG } from 'constants/labels';

const Configuration = () => {
  const header = "Role Management";
  const dispatch = useDispatch();
  const [selectedPortal, setSelectedPortal] = useState(1);
  const [data, setData] = useState(null);
  const [isRole, setIsRole] = useState(true)
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [roleData, setRoleData] = useState([]);
  const [editedRowId, setEditedRowId] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [initialData, setInitialData] = useState(null);
  const [isDigitalAdmin, setIsDigitalAdmin] = useState(false);
  const authUser = useSelector(x => x.auth?.value);
  const user = authUser?.Data;
  const userAccess = user?.UserAccess;

  const userdetails = user?.UserDetails;
  const isReviewer = userAccess?.some(access => access.Role.toLowerCase().includes('reviewer'));
  const isSuperAdmin = userAccess?.some(access => access.Role.toLowerCase().includes('digital-admin'));
  const authUserName = `${userdetails.firstName} ${userdetails.lastName}`;
  const portals = user?.UserAccess?.filter(access =>
    ["admin", "reviewer", "owner", "digital-admin"].includes(access.Role.toLowerCase())
  );
  const options = portals?.map(portal => ({
    value: portal.PortalId,
    label: portal.PortalName
  })).sort((a, b) => a.label.localeCompare(b.label));

  const portalName = options.find(option => option.value === selectedPortal)?.label;

  const { control, formState: { errors } } = useForm();

  useEffect(() => {
    fetchData();
    setIsDigitalAdmin(isSuperAdmin);
  }, [dispatch, selectedPortal, isRole]);

  const fetchData = async () => {
    try {
      dispatch(alertActions.clear());
      const result = await dispatch(
        configAction.getAccess(selectedPortal),
      ).unwrap();
      setData(result.Data);
      setInitialData(result.Data);
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header,
        }),
      );
    }
  };


  const handleChange = (newValue, rowData, field) => {

    if ((field == "ServiceProvider" || field == "MarketerName") && (newValue == null || newValue == "")) {
      setIsDataChanged(false);
    } else {
      setIsDataChanged(true);
    }
    setEditedRowId((prev) => {
      const updatedRows = { ...prev };
      if (!updatedRows[rowData.MarketerID]) {
        updatedRows[rowData.MarketerID] = { ...rowData };
      }
      updatedRows[rowData.MarketerID][field] = newValue;
      return updatedRows;
    });
    const newData = data?.Marketers?.map(row => row.MarketerID === rowData.MarketerID ? { ...row, [field]: newValue } : row);
    setData(pre => ({ ...pre, Marketers: [...newData] }));
  };
  const handlePortalChange = (value) => {
    setSelectedPortal(value);
  };

  const handleFetch = () => {
    fetchData();
    fetchRoleData();
  }
   const handleRoleChange1 = (newValue, rowData, field) => {
    setEditedRowId((prev) => {

      const updatedRows = { ...prev };
      if (!updatedRows[rowData.RoleID]) {
        updatedRows[rowData.RoleID] = { ...rowData };
      }
      updatedRows[rowData.RoleID][field] = newValue;
      return updatedRows;
    });
    const newData = roleData?.map(row =>
      row.RoleID === rowData.RoleID
        ? { ...row, [field]: newValue, isEdited: true }
        : row
    );
    setRoleData(newData)
    setData(newData)
    setIsDataChanged(true); // Set data changed to true
  };
const handleRoleChange = (newValue, rowData, field) => {
  const updatedRow = { ...rowData, [field]: newValue, isEdited: true };

  // Handle dependent field updates
  if (field === 'IsWglRole' && newValue === true) {
    updatedRow.IsCustomerRole = false;
  }

  if (field === 'PortalId' && newValue != 4) {
    updatedRow.IsCustomerRole = false;
  }
setEditedRowId(prev => ({
    ...prev,
    [rowData.RoleID]: { ...(prev[rowData.RoleID] || {}), ...updatedRow }
  }));

  
  const newData = roleData.map(row =>
    row.RoleID === updatedRow.RoleID ? updatedRow : row
  );


  setRoleData(newData);
  setData(newData);
  setIsDataChanged(true);
};


  const fetchRoleData = async () => {
    try {
      const result = await dispatch(masterActions.getAllRoles());
      setRoleData(result?.payload?.Data);
      if (result?.error) {
        dispatch(alertActions.error({
          showAfterRedirect: true,
          message: result || result?.error.message,
          header: header
        }));
        return;
      }
    }
    catch (error) {
      dispatch(alertActions.error({ message: error?.message || error, header: header }));
    }
  }

  useEffect(() => {
    dispatch(alertActions.clear());
    fetchRoleData();
  }, []);

  const handleSubmit = async (isSingle = false, singleRowData = null) => {
    dispatch(alertActions.clear());
    try {
      let editedRowData;
      let selectedRoles;

      if (isSingle && singleRowData) {
        // Handle a single object update
        editedRowData = [singleRowData]; // Wrap in an array for consistency
        selectedRoles = editedRowData;
      } else {
        // Handle multiple object updates
        editedRowData = Object.values(editedRowId);

        selectedRoles = editedRowData
          .filter((newItem) =>
            selectedRows.some((oldItem) => oldItem.RoleID === newItem.RoleID),
          )
          .map((item) => item);
      }
      const transformedData = (
        Array.isArray(selectedRoles) ? selectedRoles : []
      ).map((item) => ({
        RoleID: item.RoleID || 0,
        RoleDescription: item.RoleName,
        RoleName: item.RoleName,
        IsActive: true,
        PortalId: item.PortalId,
        IsWglRole: item.IsWglRole,
        IsCustomerRole: item.IsCustomerRole,
        PortalRoleID: item.PortalRoleID,
        CreatedBy: authUserName,
      }));
      let result = "";
      if (transformedData.length > 0) {
        transformedData.map(async (data) => {
          result = await dispatch(masterActions.updateRole(data)).unwrap();
          if (result.Succeeded) {
            dispatch(
              alertActions.success({
                message: result.Message,
                header: header,
              }),
            );
          }
        });
      }
      setTimeout(() => {
        fetchRoleData();
      }, 2000);
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header,
        }),
      );
    }
  };

  return (
    <>
      <Grid container spacing={3} className="Configurationbuttonmar-20">
        <Grid size={{ xs: 6, sm: 6, md: 6 }}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 8, sm: 8, md: 6 }} className="userprofilelist">
          
              <Typography variant="h2" className='userprofilelistcontent'>
                 <span>Role Management  </span> {isRole?"":portalName}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 6 }} className="Configurationbutton">

          <Button
            variant="contained"
            className='Download margin-25 '
            color="primary"
            onClick={() => setIsRole(!isRole)}
          > {isRole ? " Permissions" : "Manage Roles"}
          </Button>
          {isRole && isSuperAdmin &&
            <AddRole
              handleFetch={fetchRoleData}
              isDigitalAdmin = {isDigitalAdmin}
            />}
        </Grid>
      </Grid>
      {isRole ?
        <RoleList
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          setRowSelection={setRowSelection}
          handleChange={handleRoleChange}
          rowSelection={rowSelection}
          options={options}
          data={roleData}
          isReviewer={isReviewer}
          handleRefresh={fetchRoleData}
          isDigitalAdmin = {isDigitalAdmin}

        /> :
        <>
          {data && <PortalConfiguration
            control={control}
            errors={errors}
            data={data[0]}
            initialData={initialData[0]}
            options={options}
            setData={setData}
            selectedPortal={selectedPortal}
            handlePortalChange={handlePortalChange}
            portalName={portalName}
            handleFetch={handleFetch} />}</>}

      <Grid size={{ xs: 12, sm: 12, md: 12 }} className="Personal-Information">
        <Button variant="contained" color="red" className="cancelbutton" onClick={handleFetch} >
          Cancel
        </Button>
        {isRole && <Button type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className='submitbutton'
          onClick={handleSubmit}
          disabled={!isDataChanged}
        >
          Save
        </Button>}
      </Grid>
    </>
  );
}

export default Configuration;
